import { Component, OnInit } from '@angular/core';
import { Feed } from 'src/app/interfaces';
import { DataService } from 'src/app/services/data.service';
import { FeedsService } from 'src/app/services/feeds.service';

@Component({
    selector: 'feed-container',
    templateUrl: './feeds.component.html',
    styleUrls: ['./feeds.component.css']
})
export class FeedsComponent implements OnInit {

    feedsLoading: boolean = false
    feedsVisible: boolean = true
    feeds: Feed[] = []

    constructor(
        private _feedService: FeedsService,
        private _dataService: DataService,
    ) { }

    ngOnInit() {
        this._dataService.feed.subscribe(feed => this.feedsVisible = feed)
        this.feedsLoading = true
        this._feedService.fetchFeeds().subscribe(

            (data: any) => {
                this.feeds = data.feeds
                this.feedsLoading = false
            },

            (error: any) => {
                this.feedsLoading = false
            }

        )
    }

    toggleFeed() {
        
        if (this.feedsVisible) {
            this._dataService.toggleFeed(false)
        }
        else {
            this._dataService.toggleFeed(true)
        }
    }
}